import { useNavigate } from 'react-router-dom';
import { ViewDropdown } from 'shared-components';
import { IOption } from 'types';
import { InstitutionEnum } from '../ActionsToolbar/types';
import { useTranslation } from "react-i18next";

const options: IOption[] = [
  {
    label: 'University only',
    value: InstitutionEnum.INSTITUTION_UNI,
  },
  {
    label: 'Pathway only',
    value: InstitutionEnum.INSTITUTION_PATHWAY,
  },
  {
    label: 'University & Pathway',
    value: InstitutionEnum.INSTITUTION_ALl,
  },
];

const getSelectedOption = (): IOption => {
  try {
    const selectedInstitution = (localStorage.getItem('dashboard-uni-institution-value') as InstitutionEnum) || '';
    return options.find(option => option.value === selectedInstitution) || options[0];
  } catch (error) {
    return options[0];
  }
};

interface IProps {
  callbackOnSelect?: (option: IOption) => void; // used to refresh global state if needed.
}

/**
 * Dropdown that changes whether we are viewing pathway, uni, or all students.
 * Works for both the admissions workflow and the cas workflow.
 *
 * Does not access global state, only changes QSP values.
 */
export const IncludeStudentsDropdown = ({ callbackOnSelect = () => {} }: IProps) => {
    const { t } = useTranslation('common');
  const navigate = useNavigate();
  const defaultOption = getSelectedOption()!;

  const onSelect = (option: IOption) => {
    if (option?.value) {
      localStorage.setItem('dashboard-uni-institution-value', option.value);
      const params = new URLSearchParams(window.location.search);
      params.set('page', '1');
      params.set('institution', option.value || '');
      navigate({ search: params.toString() });

      callbackOnSelect(option);
    }
    return option;
  };

  return (
    <ViewDropdown label={t('common:includeStudentsFrom')} options={options} defaultOption={defaultOption} onSelect={onSelect} />
  );
};
